import React, { useEffect, useState } from "react";

const ChatInvitation = () => {
  const [username] = useState(sessionStorage.getItem("username"));
  const [userFirstname] = useState(sessionStorage.getItem("firstname"));
  const [userLastName] = useState(sessionStorage.getItem("lastName"));

  useEffect(() => {
    // Load Salesforce Messaging Script
    const loadMessaging = () => {
      if (window.embeddedservice_bootstrap) {
        initEmbeddedMessaging();
        return;
      }

      const script = document.createElement("script");
      script.src =
        "https://claritybenefitsolutions--partial.sandbox.my.site.com/ESWWorkflowPlatformChat1772802755379/assets/js/bootstrap.min.js";
      script.async = true;

      script.onload = () => {
        initEmbeddedMessaging();
      };

      document.body.appendChild(script);
    };

    // Event: Messaging Ready
    const handleReady = () => {
      console.log("Embedded Messaging Ready");

      if (window.embeddedservice_bootstrap?.prechatAPI) {
        window.embeddedservice_bootstrap.prechatAPI.setHiddenPrechatFields({
          FirstName: userFirstname || "Guest",
          LastName: userLastName || "",
          Email: username || "",
          Phone: "99999099989",
          ZipCode: "43212",
          DOB: "2000-06-14",
          Tracking_Number: "111",
          Language: "en_US",
        });
      }
    };

    window.addEventListener("onEmbeddedMessagingReady", handleReady);

    // Init function
    window.initEmbeddedMessaging = () => {
      try {
        window.embeddedservice_bootstrap.settings.language = "en_US";

        window.embeddedservice_bootstrap.init(
          "00DWA000001u9Xt",
          "Workflow_Platform_Chat_Enhanced",
          "https://claritybenefitsolutions--partial.sandbox.my.site.com/ESWWorkflowPlatformChat1772802755379",
          {
            scrt2URL:
              "https://claritybenefitsolutions--partial.sandbox.my.salesforce-scrt.com",
          }
        );
      } catch (err) {
        console.error("Error loading Embedded Messaging:", err);
      }
    };

    loadMessaging();

    // Cleanup
    return () => {
      window.removeEventListener("onEmbeddedMessagingReady", handleReady);
    };
  }, [username, userFirstname, userLastName]);

  return null; // No UI needed (Salesforce widget will render automatically)
};

export default ChatInvitation;